﻿/* eslint-disable no-magic-numbers */
import { Color } from '@technology/web3d';
import {
  normalizeRgbColor,
  denormalizeRgbColor,
  type RGBFormat,
} from '../colors/color';

/**
 * Convert standard RGB color (0-255) to Web3D Color (0-1).
 * @param color RGB color with values in 0-255 range
 * @returns Web3D Color object
 */
export function rgbToWeb3dColor(color: RGBFormat): Color {
  const normalized = normalizeRgbColor(color);
  return new Color(normalized.r, normalized.g, normalized.b);
}

/**
 * Convert Web3D Color (0-1) to standard RGB color (0-255).
 * @param color Web3D Color object with values in 0-1 range
 * @returns RGB color with values in 0-255 range
 */
export function web3dColorToRgb(color: Color): RGBFormat {
  return denormalizeRgbColor({
    r: color.r,
    g: color.g,
    b: color.b,
  });
}
